// GENERATED FILE - DO NOT MODIFY

export enum SortDirection {
    None = "None",
    Ascending = "Ascending",
    Descending = "Descending",
}